import { render, staticRenderFns } from "./SearchFootfall.vue?vue&type=template&id=45051fb0&"
import script from "./SearchFootfall.vue?vue&type=script&lang=js&"
export * from "./SearchFootfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports